<template>
 <div id="info">
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal">
      <b-row>
        <b-col cols="12" v-for="entry in entries" :key="entry.uid">
          <div class="subpage-title">
            <h2 class="font-color-red">
              {{ entry.infoTitel }}
            </h2>
          </div>
          <div class="text-h3 redactor-with-linkicon space-b2" v-html="newLineText(entry.infoText)"></div>
        </b-col>

        <b-col cols="12" v-for="(entry, i) in entries" :key="i">
          <template v-for="(block, j) in entry.infodateien">
            <div v-if="block.__typename == 'infodateien_infodatei_BlockType'" :key="j">
              <template v-for="rel in block.datei">
                  <a :href="rel.url" target="_blank" class="normallink icon-info" :key="rel.id">
                    <svg class="icon-info-desktop" height="17px" id="Ebene_1" style="enable-background:new 0 0 18.4 17.5;" version="1.1" viewbox="0 0 18.4 17.5" width="19px" x="0px" xml:space="preserve" y="0px">
                      <title>info-download-mobile+desktop</title>
                      <polygon points="10.2,15.4 18.4,7.2 17,5.8 10.2,12.6 10.2,0 8.2,0 8.2,12.6 1.4,5.8 0,7.2 8.2,15.4 8.2,15.5 0.7,15.5 0.7,17.5
                                                      17.7,17.5 17.7,15.5 10.2,15.5 "/>
                    </svg>
                    {{ block.titel }}
                  </a>
              </template>
            </div>
          </template>
        </b-col>


      </b-row>
    </b-container>
    <b-container fluid>
       <b-row>
        <b-col cols="12 space-b2">
          <p>Gestaltung & Programmierung: <a href="https://debutdebut.com/" target="_blank">Début Début</a></p>
        </b-col>   
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  const axios = require("axios");

  export default {
    name: "info",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
  },
  data() {
    return {
      entries: [],
      navigationPlaceholder: "Info"
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                entries(section: "info") {
                  title,
                  uid
                  ... on info_info_Entry {
                    infoTitel,
                    infoText
                    infodateien { # Matrix Field Handle
                    ... on infodateien_infodatei_BlockType { # Matrix Block Type
                      __typename # Ensures the response has a field describing the type of block
                      titel
                      datei {
                        url
                        id
                      }
                      }
                    }
                  }
                }
              }
            `,
      },
    }).then((result) => {
      let data = result.data.data.entries;
      // console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;
    });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 
</style>